import { withStyles } from '@material-ui/core/styles';
import { IconButton } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import {withAppConfig} from "../../../appConfigContext"
import { compose } from "recompose";

const styles = theme => ({
    aboutRMAXDialog:{
        width:"500px",
        height:"400px",
        textAlign:"center",
        padding:"0px 22px 10px 22px",
        borderRadius:"2px",
        backgroundColor: theme.ModalBGColor,
        boxShadow: "2px 2px 4px black"
    },
    rmaxTrademark:{
        width:"230px",
        paddingBottom:"35px",
        paddingLeft:"20px"
    },
    aboutRMAXContent:{
        fontSize:"16px",
        fontWeight:"600",
        lineHeight:"32px",
        overflow:"hidden",
        color: theme.gridTextColor,
    },
    titleRMAX: {
        float:"right",
        color: theme.headerIconColor,
      },
    learnMoreLink:{
        textDecoration:"underline",
        cursor:"pointer",
        '&:hover':{
            color:theme.HeaderSelectedText
        }
    },
    routeMaxLogo:{
        width:"80px",
        paddingBottom:"20px"
    },
    dialogTitleRoot:{
        padding:"20px 0px 0px 0px"
    }
})

const AboutRMAXDialog = props => {
    const {classes, show, onClose,configJSON} = props;
    const appVersion = configJSON.appVersion ? (configJSON.appVersion.split('-'))[0] : "";
    return(
        <Dialog
        open={show}
        onClose={onClose}
        classes={{paper:classes.aboutRMAXDialog}}
        aria-labelledby="about-routemax">
            <DialogTitle disableTypography={true} id="about-routemax" classes={{root: classes.dialogTitleRoot}}>
                <IconButton aria-label="Close" classes = {{root:classes.titleRMAX}} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.aboutRMAXContent}>
                <div><img src = "../../../images/RouteMAXLogo.png" className={classes.routeMaxLogo}/></div>
                <div><img src = "../../../images/RMAXTradeMark.png" className={classes.rmaxTrademark}/></div>
                <div>
                    Version {appVersion}<br/>
                    Copyright &copy; {new Date().getFullYear()} Optym<br/>
                    All Rights Reserved.<br/>
                </div>
                <div
                className={classes.learnMoreLink}
                onClick={()=>window.open("https://routemax.com/", "_blank")}>
                    Learn more
                </div>
            </DialogContent>
        </Dialog>
        )
}

export default compose(withStyles(styles),withAppConfig)(AboutRMAXDialog);